import { SuperuserSkillEditorPage } from "@/features/superuser/skills/superuser-skill-editor.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/superuser/skills/$skillId")({
  component: SuperuserSkillEditRoute,
});

function SuperuserSkillEditRoute() {
  const { skillId } = Route.useParams();
  return <SuperuserSkillEditorPage skillId={skillId} />;
}
